import Empty from './Empty.vue';

export default Empty;
